var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 496H16V256H496V496Z",
    fill: "#2980B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 256H16V16H496V256Z",
    fill: "#E74C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 186H16V326H496V186Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 496H18.7187L86.8437 427.648L256 257.928V256.799L16 16V496Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 466H18.3789L77.9883 406.192L226 257.687V256.7L16 46V466Z",
    fill: "#27AE60"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M496 206H16V306H496V206Z",
    fill: "#27AE60"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 376H17.3594L51.4219 341.824L136 256.964V256.4L16 136V376Z",
    fill: "#F1C40F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 343.5H16.9912L41.8284 318.58L103.5 256.703V256.291L16 168.5V343.5Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZa);
export default __webpack_public_path__ + "static/media/ZA.cf177befcbcce553bb07764a22b54fbb.svg";
export { ForwardRef as ReactComponent };